<input #field
       type="text"
       class="form-control"
       [ngModel]="innerValue"
       (ngModelChange)="writeValue($event)"
       (blur)="onTouched()"
       maxlength="8"
       [placeholder]="placeholder || ''">
